var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zM7.431 3.348 6.138 5.933l-2.895.416a.623.623 0 0 0-.35 1.067l2.093 2.011-.495 2.842c-.089.513.46.898.92.658L8 11.585l2.59 1.342c.46.238 1.008-.145.919-.658l-.495-2.842 2.094-2.011a.623.623 0 0 0-.35-1.067l-2.896-.416L8.57 3.348a.639.639 0 0 0-1.138 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentOther);
export default __webpack_public_path__ + "static/media/incident-other.5c395d2a0e6dce78cb18f4d5708180df.svg";
export { ForwardRef as ReactComponent };